import React from 'react';
import { useTranslation } from 'react-i18next';
import { ControlBarButton } from '@m12s/component-library';
import { sync } from 'lib/icons';
import { useSelector } from 'react-redux';
import { getSwitchActivityTypesOptions } from 'lib/selectors/getSwitchActivityTypesOptions';
import useSelectActivity from 'lib/hooks/useSelectActivity';
import { MobileIcon, ResponsiveText } from '../styled';

/**
 * SwitchActivity component renders a button to switch between different activity types
 * for a machine. The button is only shown if there are multiple activity types available
 * and the machine is not paused.
 *
 * @param {Object} props
 * @returns {React.ReactElement|null} Returns the switch activity button or null if only one activity type is available or machine is paused
 */
const SwitchActivity = () => {
  const { t } = useTranslation();
  const activityTypes = useSelector(getSwitchActivityTypesOptions);
  const { openSelectActivity } = useSelectActivity();

  // if there are multiple activity types options, show the switch activity button
  if (activityTypes?.length > 1) {
    return (
      <ControlBarButton
        id="job-control-switch-activity"
        onClick={() => {
          return openSelectActivity();
        }}
      >
        <MobileIcon icon={sync} />
        <ResponsiveText
          full={t('switchActivity|full')}
          medium={t('switchActivity|medium')}
          short={t('switchActivity|short')}
        />
      </ControlBarButton>
    );
  }

  return null;
};

export { SwitchActivity };
